import { Web3WalletType } from 'src/app/shared/interfaces/auth.interface';

export const walletConfig = [
  {
    name: Web3WalletType.MetaMask,
    iconUrl: 'assets/images/login-wallets/metamask.svg',
  },
  {
    name: Web3WalletType.TonConnect,
    iconUrl: 'assets/images/login-wallets/tonconnect.svg',
  },
  {
    name: Web3WalletType.CoinbaseWallet,
    iconUrl: 'assets/images/login-wallets/coinbasewallet.svg',
  },
  {
    name: Web3WalletType.WalletConnect,
    iconUrl: 'assets/images/login-wallets/walletconnect.svg',
  },
];

export const walletDesc = [
  { type: 'Main', desc: 'w_view_main_tip' }, //主账号
  { type: 'Ky', desc: 'ky_start' }, //开源棋牌
  { type: 'Rg', desc: 'py_start' }, //雷竞技
  { type: 'Ag', desc: 'ag_start' },
  { type: 'BoyaChess', desc: 'boya_desc' }, //博雅棋牌
  { type: 'AGSlot', desc: 'new_ag_desc' }, //新AG电子
  { type: 'Golden', desc: 'golden_desc' }, //高登棋牌
  { type: 'YYChess', desc: 'yy_desc' }, //YOO棋牌
  { type: 'GPIChess', desc: 'gpi_desc' }, //GPI棋牌
  { type: 'KYChess', desc: 'ky_desc' }, //开源棋牌
  { type: 'SGWinChess', desc: 'sg_desc' }, //双赢棋牌
  { type: 'FCHunter', desc: 'fchunter_desc' }, //FC捕鱼
  { type: 'Baison', desc: 'baison_desc' }, //百盛棋牌
  { type: 'JDBGame', desc: 'jdb_desc' }, //JDB 电子
  { type: 'BBINLive', desc: 'bbinlive_desc' }, //BBIN 真人
];

export const walletTypesToNames: Partial<Record<Web3WalletType, string>> = {
  [Web3WalletType.MetaMask]: 'MetaMask',
  [Web3WalletType.CoinbaseWallet]: 'Base',
  [Web3WalletType.TonConnect]: 'TON Connect',
  [Web3WalletType.WalletConnect]: 'WalletConnect',
};
